import { Injectable, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { Lista2Service } from './lista2.service';
import { WebSocketService } from './websocket.service';
import { ReconciliacionWs } from './ws-reconciliacion';
import { LoginService } from '../../modulos/login/login.service';

/**
 * Mantiene el conteo global de materiales de servicio técnico PENDIENTES de
 * aprobación (tipo 'pedido', estado 'Pendiente') para el badge del navigator.
 * Igual que el contador de eventos vivos, pero SIN sonido ni notificación.
 */
@Injectable({ providedIn: 'root' })
export class MaterialesPendientesService {
  private lista2 = inject(Lista2Service);
  private wsService = inject(WebSocketService);

  private reconciliacionWs = new ReconciliacionWs(this.wsService, {
    entidades: ['materialesserviciotecnico'],
    idPermiso: () => LoginService.getIdPermiso(),
    relistar: () => this.listar(),
  });

  public totalCount = 0;
  private sub?: Subscription;

  private listar(): void {
    this.sub?.unsubscribe();
    const filter = JSON.stringify({ tipo: 'pedido', estado: 'Pendiente' });
    this.sub = this.lista2
      .materialesServicioTecnico(
        { filter, includeChildren: true, limit: 1 },
        this.reconciliacionWs.intervaloActual(),
      )
      .subscribe((res) => {
        this.totalCount = res.totalCount;
      });
  }

  public iniciarServicio(): void {
    this.reconciliacionWs.iniciar();
    this.listar();
  }

  public reiniciar(): void {
    this.sub?.unsubscribe();
    this.totalCount = 0;
    this.reconciliacionWs.iniciar();
    this.listar();
  }
}
